/* eslint-disable */
import { produce } from "immer";
import {
  LIFE_ASSURANCE_FETCH_FAILURE,
  LIFE_ASSURANCE_FETCH_SUCCESS,
  LIFE_ASSURANCE_FETCH_START,
} from "../actions/types";

const lifeAssurance = (
  state = {
    lifeFetching: false,
    lifeData: [],
    lifeError: null,
  },
  action,
) => {
  switch (action.type) {
    case LIFE_ASSURANCE_FETCH_START:
      return produce(state, (draft) => {
        draft.lifeFetching = true;
      });
    case LIFE_ASSURANCE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.lifeFetching = true;
        draft.lifeData = action.data;
        draft.lifeFetching = false;
      });
    case LIFE_ASSURANCE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.lifeFetching = false;
        draft.lifeError = action.error;
      });
    default:
      return state;
  }
};

export default lifeAssurance;
